import React from 'react';
import { useInput } from 'react-admin';
import { makeStyles } from '@material-ui/core';

import CheckBoxInput from '../../../core/components/inputs/CheckBoxInput';

const useFilterStyles = makeStyles({
  checkBoxInput: {
    display: 'flex',
    marginTop: '17px'
  }
});

/**
 * Input for boolean filter
 * @param {*} props
 */
const CheckBoxFilter = props => {
  const { source, label, variant } = props;
  const { input, meta } = useInput(props);
  const classes = useFilterStyles(props);

  return (
    <CheckBoxInput
      {...input}
      {...meta}
      source={source}
      label={label}
      variant={variant}
      className={classes.checkBoxInput}
    />
  );
};

export default CheckBoxFilter;
